let registerPhoneNumber = ''
let isRegisterOtpSent = false
const storefrontDomain = window.location.hostname.toLowerCase()

// List of allowed country codes (as strings, without '+')
const ALLOWED_PHONE_CODES = [
  '995', // GE
  '49', // DE
  '33', // FR
  '39', // IT
  '34', // ES
  '1', // US, CA
  '44', // GB
  '48', // PL
  '90', // TR
  '994', // AZ
  '374', // AM
  '7', // RU, KZ
  '380', // UA
  '375', // BY
  '998', // UZ
  '992', // TJ
  '996', // KG
  '86', // CN
  '81', // JP
  '82', // KR
]

function startsWithAllowedCode(cleaned) {
  return ALLOWED_PHONE_CODES.some((code) => cleaned.startsWith(code))
}

function isGeorgianLocal(number) {
  return /^5\d{8}$/.test(number)
}

function isValidPhoneNumber(input) {
  const cleaned = input.replace(/\D/g, '')

  if (isGeorgianLocal(cleaned)) return true

  return startsWithAllowedCode(cleaned) && cleaned.length >= 8
}

function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function formatPhoneNumber(number) {
  const cleaned = number.replace(/\D/g, '')
  if (isGeorgianLocal(cleaned)) return '995' + cleaned
  return cleaned
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize numeric filtering for identification number field
  const identificationNumberInputs = document.querySelectorAll('[data-input="identification_number"]')
  identificationNumberInputs.forEach(input => {
    input.addEventListener('input', (e) => {
      // Remove non-numeric characters in real-time
      const cleaned = e.target.value.replace(/[^\d]/g, '')
      if (cleaned !== e.target.value) {
        e.target.value = cleaned
        console.log('Identification number filtered to numeric only:', cleaned)
      }
      
      // Remove invalid class if length is acceptable
      if (cleaned.length >= 11) {
        e.target.classList.remove('invalid')
      }
    })
  })

  const loginTogglerButtons = document.querySelectorAll('.login_form_toggler_button')
  const isLoginPage = document.body.classList.contains('template-customers-login')

  const emailLoginCont = document.querySelector('.email_login_cont')
  const otpLoginCont = document.querySelector('.otp_login_cont')
  const emailRegisterCont = document.querySelector('.email_register_cont')
  const otpRegisterCont = document.querySelector('.otp_register_cont')

  function toggleInputState(container, isEnabled) {
    container.querySelectorAll('input').forEach((input) => {
      input.disabled = !isEnabled
    })
  }

  loginTogglerButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      loginTogglerButtons.forEach((btn) => {
        btn.classList.remove('active')
      })

      if (index === 1) {
        document.querySelector('.login_form_toggler').classList.add('switched')

        if (isLoginPage) {
          emailLoginCont.style.display = 'flex'
          otpLoginCont.style.display = 'none'
          toggleInputState(emailLoginCont, true)
          toggleInputState(otpLoginCont, false)
        } else {
          emailRegisterCont.style.display = 'flex'
          otpRegisterCont.style.display = 'none'
          toggleInputState(emailRegisterCont, true)
          toggleInputState(otpRegisterCont, false)
        }
      } else {
        document.querySelector('.login_form_toggler').classList.remove('switched')

        if (isLoginPage) {
          emailLoginCont.style.display = 'none'
          otpLoginCont.style.display = 'flex'
          toggleInputState(emailLoginCont, false)
          toggleInputState(otpLoginCont, true)
        } else {
          emailRegisterCont.style.display = 'none'
          otpRegisterCont.style.display = 'grid'
          toggleInputState(emailRegisterCont, false)
          toggleInputState(otpRegisterCont, true)
        }
      }
      button.classList.add('active')
    })
  })

  if (otpRegisterCont) {
    const registerFirstNameInput = otpRegisterCont.querySelector('[data-input="first_name"]')
    const registerLastNameInput = otpRegisterCont.querySelector('[data-input="last_name"]')
    const registerEmailInput = otpRegisterCont.querySelector('[data-input="email"]')
    const registerPhoneInput = otpRegisterCont.querySelector('[data-input="phone"]')
    const marketingConsentCheckbox = otpRegisterCont.querySelector('[data-marketing-consent]')
    const marketingConsentEndpoint = otpRegisterCont.dataset.marketingConsentEndpoint || 'https://general.meama.ge/api/customers/change-marketing-consent'
    const marketingConsentToken = otpRegisterCont.dataset.marketingConsentToken || ''
    const registerSendOtpButton = otpRegisterCont.querySelector('#sendOtp')
    const registerOtpCont = otpRegisterCont.querySelector('.otp_cont_register')
    const registerOtpInputs = otpRegisterCont.querySelectorAll('.otp_input')
    const verifyOtpButton = otpRegisterCont.querySelector('#verifyOtp')

    const statusMessageBox = document.getElementById('otp-status-message')

    async function submitMarketingConsent(email) {
      if (!marketingConsentCheckbox?.checked || !email || !marketingConsentEndpoint) return

      const headers = { 'Content-Type': 'application/json' }
      if (marketingConsentToken) {
        headers.Authorization = `Bearer ${marketingConsentToken}`
      }

      try {
        const response = await fetch(marketingConsentEndpoint, {
          method: 'POST',
          headers,
          body: JSON.stringify({
            email,
            emailMarketingConsent: true,
            smsMarketingConsent: true,
          }),
        })

        if (!response.ok) {
          const errorText = await response.text()
          console.warn('Marketing consent update failed', errorText)
        }
      } catch (error) {
        console.error('Marketing consent error', error)
      }
    }

    function updateVerifyButtonState() {
      const allFilled = Array.from(registerOtpInputs).every((input) => input.value.length === 1)
      verifyOtpButton.disabled = !allFilled
    }

    function showStatus(message, isError = false) {
      if (!statusMessageBox) return
      statusMessageBox.textContent = message
      statusMessageBox.className = 'status-message'
      statusMessageBox.classList.add(isError ? 'error' : 'success')
      statusMessageBox.style.display = 'block'
      if (window.statusTimeout) clearTimeout(window.statusTimeout)
      window.statusTimeout = setTimeout(
        () => {
          statusMessageBox.style.display = 'none'
        },
        isError ? 5000 : 3000
      )
    }

    registerPhoneInput?.addEventListener('input', (e) => {
      let number = e.target.value
      
      // Remove non-numeric characters from phone input in real-time
      const cleaned = number.replace(/[^\d+-\s()]/g, '')
      if (cleaned !== number) {
        e.target.value = cleaned
      }
      
      if (!isValidPhoneNumber(e.target.value)) {
        registerPhoneInput.classList.add('invalid')
      } else {
        registerPhoneInput.classList.remove('invalid')
      }
    })
    
    // Prevent non-numeric characters from being entered in phone field
    registerPhoneInput?.addEventListener('keypress', (e) => {
      // Allow: backspace, delete, tab, escape, enter, space, dash, plus, parentheses
      if ([8, 9, 27, 13, 32, 46, 45, 43, 40, 41].indexOf(e.keyCode) !== -1 ||
        // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })

    registerOtpInputs.forEach((input, index) => {
      input.setAttribute('name', `otp_${index + 1}`)

      input.addEventListener('input', (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 1)
        e.target.value = value
        if (value) {
          const nextInput = registerOtpInputs[index + 1]
          if (nextInput) nextInput.focus()
        }
        updateVerifyButtonState()
      })

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace' && !e.target.value) {
          const prevInput = registerOtpInputs[index - 1]
          if (prevInput) {
            prevInput.focus()
            prevInput.value = ''
          }
        }
        if (e.key === 'Enter') {
          e.preventDefault()
          if (index === registerOtpInputs.length - 1) {
            verifyOtpButton?.click()
          } else {
            const nextInput = registerOtpInputs[index + 1]
            if (nextInput) nextInput.focus()
          }
        }
      })

      input.addEventListener('paste', (e) => {
        e.preventDefault()
        const pastedData = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, registerOtpInputs.length)
        if (pastedData) {
          registerOtpInputs.forEach((input, i) => {
            input.value = pastedData[i] || ''
          })
          const lastFilledIndex = Math.min(pastedData.length - 1, registerOtpInputs.length - 1)
          if (lastFilledIndex < registerOtpInputs.length - 1) {
            registerOtpInputs[lastFilledIndex + 1]?.focus()
          }
        }
      })
    })

    updateVerifyButtonState()

    registerPhoneInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        if (!registerSendOtpButton.disabled) {
          registerSendOtpButton?.click()
        }
      }
    })

    registerSendOtpButton?.addEventListener('click', async () => {
      registerSendOtpButton.disabled = true

      const firstName = registerFirstNameInput.value.trim()
      const lastName = registerLastNameInput.value.trim()
      const email = registerEmailInput?.value.trim() || ''
      
      // Get identification number
      const identificationNumberInputs = document.querySelectorAll('[data-input="identification_number"]')
      let identificationNumber = ""
      for (const input of identificationNumberInputs) {
        if (input.value && input.value.trim()) {
          identificationNumber = input.value.trim()
          break
        }
      }
      identificationNumber = identificationNumber.replace(/[^\d]/g, '')

      // Collect all validation errors before showing them
      let hasErrors = false
      
      // Validate first name
      if (!firstName || firstName.length < 3) {
        registerFirstNameInput.classList.add('invalid')
        hasErrors = true
      } else {
        registerFirstNameInput.classList.remove('invalid')
      }
      
      // Validate last name
      if (!lastName || lastName.length < 3) {
        registerLastNameInput.classList.add('invalid')
        hasErrors = true
      } else {
        registerLastNameInput.classList.remove('invalid')
      }
      
      // Validate email
      if (!email || !isValidEmail(email)) {
        registerEmailInput?.classList.add('invalid')
        hasErrors = true
      } else {
        registerEmailInput?.classList.remove('invalid')
      }
      
      // Identification number OPTIONAL
      if (identificationNumber && identificationNumber.length < 11) {
        identificationNumberInputs.forEach(input => input.classList.add('invalid'))
        showStatus('გთხოვთ შეიყვანოთ სწორი პირადი ნომერი (მინიმუმ 11 ციფრი)', true)
        hasErrors = true
      } else {
        identificationNumberInputs.forEach(input => input.classList.remove('invalid'))
      }

      registerPhoneNumber = formatPhoneNumber(registerPhoneInput.value)

      // Validate phone number
      if (!isValidPhoneNumber(registerPhoneInput.value)) {
        registerPhoneInput.classList.add('invalid')
        hasErrors = true
      } else {
        registerPhoneInput.classList.remove('invalid')
      }

      // If there are any errors, show appropriate message and return
      if (hasErrors) {
        if (!firstName || firstName.length < 2) {
          showStatus('სახელი სავალდებულოა და უნდა იყოს მინიმუმ 2 სიმბოლო', true)
        } else if (!lastName || lastName.length < 2) {
          showStatus('გვარი სავალდებულოა და უნდა იყოს მინიმუმ 2 სიმბოლო', true)
        } else if (!email || !isValidEmail(email)) {
          showStatus('Please enter a valid email address.', true)
        } else if (!identificationNumber || identificationNumber.length < 11) {
          showStatus('გთხოვთ შეიყვანოთ სწორი პირადი ნომერი (მინიმუმ 11 ციფრი)', true)
        } else if (!isValidPhoneNumber(registerPhoneInput.value)) {
          showStatus('გთხოვთ შეიყვანოთ სწორი ტელეფონის ნომერი', true)
        }
        registerSendOtpButton.disabled = false
        return
      }

      try {
        const response = await fetch('https://otp-auth.meama.ge/api/auth/send-otp', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phoneNumber: registerPhoneNumber }),
        })

        if (response.status === 429) {
          throw new Error('ძალიან ბევრი მოთხოვნა. გთხოვთ სცადოთ მოგვიანებით.\nToo many OTP requests, please try again later.')
        }

        const data = await response.json()

        if (data.success) {
          isRegisterOtpSent = true
          registerPhoneInput.parentElement.style.display = 'none'
          if (registerOtpCont) registerOtpCont.style.display = 'flex'
          showStatus('კოდი გამოგზავნილია', false)
        } else {
          throw new Error(data.message || 'სერვერთან დაკავშირება ვერ მოხერხდა')
        }
      } catch (error) {
        showStatus(error.message, true)
        console.error('Error:', error)
      } finally {
        registerSendOtpButton.disabled = false
      }
    })

    verifyOtpButton?.addEventListener('click', async (e) => {
      e.preventDefault()
      const otp = Array.from(registerOtpInputs)
        .map((input) => input.value)
        .join('')
      const firstName = registerFirstNameInput.value.trim()
      const lastName = registerLastNameInput.value.trim()
      const email = registerEmailInput?.value.trim() || ''

      // Extract identification number at the START
      const identificationNumberInputs = document.querySelectorAll('[data-input="identification_number"]')
      let identificationNumber = ""
      
      // Check both hardcoded field and dynamically rendered field
      for (const input of identificationNumberInputs) {
        if (input.value && input.value.trim()) {
          identificationNumber = input.value.trim()
          break
        }
      }

      // Filter to numeric only (in case user pasted non-numeric)
      identificationNumber = identificationNumber.replace(/[^\d]/g, '')

      console.log('DEBUG: Extracted identification number:', identificationNumber || '(empty)')
      console.log('DEBUG: Identification number length:', identificationNumber.length)

      // Collect all validation errors before showing them
      let hasErrors = false
      
      // Validate first name
      if (!firstName || firstName.length < 3) {
        registerFirstNameInput.classList.add('invalid')
        hasErrors = true
      } else {
        registerFirstNameInput.classList.remove('invalid')
      }
      
      // Validate last name
      if (!lastName || lastName.length < 3) {
        registerLastNameInput.classList.add('invalid')
        hasErrors = true
      } else {
        registerLastNameInput.classList.remove('invalid')
      }
      
      // Validate email
      if (!email || !isValidEmail(email)) {
        registerEmailInput?.classList.add('invalid')
        hasErrors = true
      } else {
        registerEmailInput?.classList.remove('invalid')
      }
      
      // Identification number OPTIONAL
      if (identificationNumber && identificationNumber.length < 11) {
        identificationNumberInputs.forEach(input => input.classList.add('invalid'))
        showStatus('გთხოვთ შეიყვანოთ სწორი პირადი ნომერი (მინიმუმ 11 ციფრი)', true)
        hasErrors = true
      } else {
        identificationNumberInputs.forEach(input => input.classList.remove('invalid'))
      }

      // Validate OTP
      if (!otp) {
        showStatus('გთხოვთ შეიყვანოთ კოდი', true)
        return
      }

      // If there are any errors in name/surname/identification, show appropriate message and return
      if (hasErrors) {
        if (!firstName || firstName.length < 2) {
          showStatus('სახელი სავალდებულოა და უნდა იყოს მინიმუმ 2 სიმბოლო', true)
        } else if (!lastName || lastName.length < 2) {
          showStatus('გვარი სავალდებულოა და უნდა იყოს მინიმუმ 2 სიმბოლო', true)
        } else if (!email || !isValidEmail(email)) {
          showStatus('Please enter a valid email address.', true)
        } else if (!identificationNumber || identificationNumber.length < 11) {
          showStatus('გთხოვთ შეიყვანოთ სწორი პირადი ნომერი (მინიმუმ 11 ციფრი)', true)
        }
        return
      }

      verifyOtpButton.disabled = true
      try {
        // First verify the OTP
        const verifyResponse = await fetch('https://otp-auth.meama.ge/api/auth/verify-otp', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            phoneNumber: registerPhoneNumber,
            otp, storefrontDomain,
            // No identificationNumber here - verify-otp doesn't need it
          }),
        })

        const verifyData = await verifyResponse.json()

        if (verifyData.success || (verifyData.redirectUrl && verifyData.redirectUrl.includes('/account/register'))) {
          // OTP is verified, now register the user
          showStatus('მიმდინარეობს რეგისტრაცია...', false)

          try {
            const registerResponse = await fetch('https://otp-auth.meama.ge/api/auth/register-otp', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                phoneNumber: registerPhoneNumber,
                firstName,
                lastName,
                otp,
                email,
                identificationNumber, // NOW INCLUDED
                storefrontDomain,
              }),
            })

            const registerData = await registerResponse.json()

            if (registerData.success) {
              if (registerOtpCont) registerOtpCont.style.display = 'none'
              showStatus(registerData.message || 'წარმატებით გაიარეთ რეგისტრაცია!', false)

              if (marketingConsentCheckbox?.checked && email) {
                await submitMarketingConsent(email)
              }

              if (registerData.redirectUrl) {
                window.location.href = registerData.redirectUrl
              }
            } else {
              showStatus(registerData.message || 'რეგისტრაცია ვერ მოხერხდა', true)
            }
          } catch (registerError) {
            showStatus('რეგისტრაციისას დაფიქსირდა შეცდომა', true)
            console.error('Registration error:', registerError)
          }
        } else {
          // If it's not a "Please register" message but an actual OTP error
          if (!verifyData.message || !verifyData.message.includes('Please register')) {
            showStatus(verifyData.message || 'არასწორი კოდი', true)
            if (verifyData.remainingAttempts) {
              showStatus(`დარჩენილი მცდელობების რაოდენობა: ${verifyData.remainingAttempts}`, true)
            }
          }
        }
      } catch (error) {
        showStatus('ვერიფიკაციისას დაფიქსირდა შეცდომა', true)
        console.error('Error:', error)
      } finally {
        verifyOtpButton.disabled = false
      }
    })

    if (registerOtpCont) registerOtpCont.style.display = 'none'
  }
})
